export type SnackbarType = "success" | "error" | "warning" | "info";

export const SNACKBAR_TOKENS = {
  success: {
    "--snackbar-bg": "var(--beautyberry)",
    "--snackbar-text": "var(--wild-hare)",
    "--snackbar-close-icon": "var(--starlight)",
  },
  error: {
    "--snackbar-bg": "var(--error)",
    "--snackbar-text": "var(--bc-white)",
    "--snackbar-close-icon": "var(--bc-white)",
  },
  warning: {
    "--snackbar-bg": "var(--warning)",
    "--snackbar-text": "var(--bc-white)",
    "--snackbar-close-icon": "var(--bc-white)",
  },
  info: {
    "--snackbar-bg": "var(--info)",
    "--snackbar-text": "var(--bc-white)",
    "--snackbar-close-icon": "var(--bc-white)",
  },
};

export const SNACKBAR_FEATURES = {
  success: { showIcon: true },
  error: { showIcon: true },
  warning: { showIcon: true },
  info: { showIcon: true },
};
